import { PasswordInput } from '@mantine/core';
import { isString } from 'lodash/fp';
import React, { FC } from 'react';

import { FieldRendererProps } from '@portals/types';

const TextField: FC<FieldRendererProps> = ({
  error,
  field,
  value,
  handleBlur,
  setFieldValue,
  readOnly,
  disabled,
  required,
}) => {
  const { name, title, placeholder, inputProps } = field;
  const { startAdornment, ...restInputProps } = inputProps || {};

  return (
    <PasswordInput
      error={error}
      data-testid={'password-input-' + name}
      icon={startAdornment}
      label={title}
      name={name}
      required={required}
      placeholder={placeholder || (isString(title) ? title : '')}
      value={value}
      disabled={disabled || readOnly}
      onChange={(event) => setFieldValue(field.name, event.target.value)}
      onBlur={handleBlur}
      {...restInputProps}
    />
  );
};

export default TextField;
